var _path, _path2, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomBellPin = function SvgCustomBellPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.27 2.67a6.336 6.336 0 0 0-8.568 5.217l-.251 2.266-.007.055a7.25 7.25 0 0 1-.972 2.88l-.028.048-.578.964-.02.032c-.246.41-.459.765-.599 1.063-.142.301-.274.67-.21 1.078.067.418.282.797.606 1.069.316.265.7.342 1.032.375.328.033.742.033 1.22.033h12.21c.478 0 .892 0 1.22-.033.332-.033.716-.11 1.032-.375a1.75 1.75 0 0 0 .605-1.07c.065-.406-.067-.776-.21-1.077-.14-.298-.352-.653-.598-1.063l-.02-.032-.578-.964-.028-.047a7.247 7.247 0 0 1-.847-2.135 5.046 5.046 0 0 1-1.535-.027 8.751 8.751 0 0 0 1.093 2.93l.031.051.578.963c.271.452.444.741.548.963.064.135.079.2.082.219a.25.25 0 0 1-.073.13.964.964 0 0 1-.23.042c-.244.024-.581.025-1.107.025H5.932c-.526 0-.863 0-1.107-.025a.963.963 0 0 1-.23-.043.25.25 0 0 1-.073-.13.967.967 0 0 1 .082-.218c.104-.222.277-.511.548-.963l.578-.963.03-.052a8.75 8.75 0 0 0 1.175-3.477l.006-.06.252-2.267a4.836 4.836 0 0 1 6.238-4.086c.212-.476.497-.913.84-1.296Zm2.504 1.75c-.44.341-.733.862-.77 1.453.336.495.583 1.057.718 1.665a1.992 1.992 0 0 0 1.586.438l-.01-.09a6.315 6.315 0 0 0-1.524-3.466Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.102 17.665c.171.957.548 1.802 1.072 2.405.524.603 1.166.93 1.826.93.66 0 1.302-.327 1.826-.93s.9-1.448 1.072-2.405",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 2.75,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};

export default SvgCustomBellPin;